import gql from "graphql-tag";

const GET_LEADS_COUNT = gql`
  query getLeadsCount($input: LeadCountFilter) {
    getTotalLeadsCount(filter: $input)
  }
`;

export default GET_LEADS_COUNT;
